import { Redirect } from 'expo-router';
import React from 'react';

const CheckImageCapture = () => {
  return <Redirect href="/move-money/check-deposit" />;
};

export default CheckImageCapture;
